//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'Login',
  data: function data() {
    return {
      userLoginInfo: {
        username: '',
        password: ''
      }
    };
  },

  methods: {
    userlogin: function userlogin() {
      if (!!this.userLoginInfo.username && !!this.userLoginInfo.password) {
        this.$emit('userLogin', this.userLoginInfo);
      } else {
        alert('Username and Password cannot be EMPTY');
      }
    },
    enterKey: function enterKey(event) {
      console.log('\n\n ===== LoginPage <|-- enterKey() ===== \n', event.code, '\n --------');
      if (event.code == 'Enter') {
        this.userlogin();
      }
    }
  },
  fetch: function fetch(_ref) {
    var store = _ref.store,
        redirect = _ref.redirect;

    if (!!store) {
      return redirect('/');
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/home/ubuntu/BookingSystemV2/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/Login.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/home/ubuntu/BookingSystemV2/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/Login.vue
// module chunks = 7